/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Exercise_Goal_Limit_ReachedInputs */

const en_us2_exercise_goal_limit_reached = /** @type {(inputs: Exercise_Goal_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can have up to ${i?.max} goals at once. Remove one first.`)
};

const pt_br2_exercise_goal_limit_reached = /** @type {(inputs: Exercise_Goal_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você pode ter até ${i?.max} metas ao mesmo tempo. Remova uma antes.`)
};

const es_419_exercise_goal_limit_reached = /** @type {(inputs: Exercise_Goal_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puedes tener hasta ${i?.max} metas a la vez. Quita una primero.`)
};

const pt_pt2_exercise_goal_limit_reached = /** @type {(inputs: Exercise_Goal_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podes ter até ${i?.max} metas ao mesmo tempo. Remove uma primeiro.`)
};

const fr_fr2_exercise_goal_limit_reached = /** @type {(inputs: Exercise_Goal_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu peux avoir ${i?.max} objectifs à la fois au maximum. Supprimes-en un d'abord.`)
};

const de_de2_exercise_goal_limit_reached = /** @type {(inputs: Exercise_Goal_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du kannst bis zu ${i?.max} Ziele gleichzeitig haben. Entferne zuerst eines.`)
};

const it_it2_exercise_goal_limit_reached = /** @type {(inputs: Exercise_Goal_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puoi avere al massimo ${i?.max} obiettivi alla volta. Rimuovine uno prima.`)
};

/**
* | output |
* | --- |
* | "You can have up to {max} goals at once. Remove one first." |
*
* @param {Exercise_Goal_Limit_ReachedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_goal_limit_reached = /** @type {((inputs: Exercise_Goal_Limit_ReachedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Goal_Limit_ReachedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_goal_limit_reached(inputs)
	if (locale === "es-419") return es_419_exercise_goal_limit_reached(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_goal_limit_reached(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_goal_limit_reached(inputs)
	if (locale === "de-DE") return de_de2_exercise_goal_limit_reached(inputs)
	if (locale === "it-IT") return it_it2_exercise_goal_limit_reached(inputs)
	return en_us2_exercise_goal_limit_reached(inputs)
});
export { exercise_goal_limit_reached as "exercise_goal.limit_reached" }